import React, { Component, useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { flattenErrors } from './ErrorHelpers';
import moment from 'moment';
import { createEvent } from 'ics';

const years = Array.from(new Array(20), (x, i) => i + new Date().getFullYear());

export function BookEventComponent({ accountNumber, bottomMessage, refundText, eventId }) {
    const [loading, setLoading] = useState(true);
    const [selectedEvent, changeSelectedEvent] = useState(null);
    const [currentScreen, setScreen] = useState(1);
    const [creditCardForm, setCreditCardForm] = useState({});
    const [errors, setErrors] = useState(null);
    const [address, setAddress] = useState({});
    const [tax, setTax] = useState(0);
    const [rsvpId, setRsvpId] = useState(null);

    function updateAddress(e) {
        setAddress({
            ...address,
            [e.target.name]: e.target.value
        });
    }

    function updateCreditCardForm(e) {
        setCreditCardForm({
            ...creditCardForm,
            [e.target.name]: e.target.value
        });
    }

    useEffect(function () {
        fetch(`/api/events/${eventId}/talent/${accountNumber}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {
                    req.json().then(event => {
                        event.dateTime = moment(event.dateTime);
                        event.friendlyDateTime = event.friendlyDateTime;
                        changeSelectedEvent(event);
                        setScreen(2);
                    });
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    },
        []);

    function book() {
        setErrors(null);
        setLoading(true);
        fetch(`/api/talent/${accountNumber}/photoshoot/book`,
            {
                method: "POST",
                body: JSON.stringify({
                    ...address,
                    EventId: eventId,
                    Payment: creditCardForm,
                    Source: "Booked by talent on Book Event page"
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {

                    req.json().then(rsvp => {
                        setRsvpId(rsvp.id);
                        setScreen(3);
                    });
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    }

    function goNext() {
        setErrors(null);
        setLoading(true);
        fetch(`/api/talent/${accountNumber}/photoshoot/calculatesalestax`,
            {
                method: "POST",
                body: JSON.stringify({
                    ...address,
                    eventId: eventId
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(req => {
                setLoading(false);
                if (req.ok) {
                    req.json().then(resp => {
                        setTax(resp.tax);
                        setScreen(2);
                    });
                } else {
                    req.json().then(resp => setErrors(resp.errors));
                }
            });
    }

    function getCurrentEventAddress() {
        const location = selectedEvent.eventLocation;
        return `${location.address1}, ${location.address2 || ""}${(location.address2 && ", ") || ""}${location.city}, ${location.state}, ${location.zip}`;
    }

    function downloadIcs() {
        const e = selectedEvent;
        const d = e.dateTime;
        const event = {
            start: [d.year(), d.month(), d.day(), d.hour(), d.minute()],
            duration: {
                minutes: e.durationInMinutes
            },
            title: "Photoshoot",
            description: "Photoshoot",
            location: getCurrentEventAddress(),
            url: "https://www.jcasablancas.com",
            status: "CONFIRMED",
            busyStatus: "BUSY"
        };

        createEvent(event,
            (error, value) => {
                window.open("data:text/calendar;charset=utf8," + escape(value));
            });
    }

    return (
        <>
{currentScreen === 1 && <div className="text-center">Loading...</div>}
            {currentScreen === 2 && <div className="col-md-12 col-lg-10 col-xl-8 offset-md-0 offset-lg-1 offset-xl-2">
                <div className="card">
                    <div className="card-body">
                        {errors && <ul>
                            {Object.keys(errors).flatMap(key => errors[key].map(error => <li>{error}</li>))}
                        </ul>}

                        <h2>{selectedEvent.description}</h2>

                        <h4>Date/Time: {selectedEvent.friendlyDateTime}</h4>

                        {selectedEvent.eventLocation && <address>
                            <strong>
                                {selectedEvent.eventLocation.name}
                            </strong><br />

                            {selectedEvent.eventLocation.address1}<br />
                            {selectedEvent.eventLocation.address2}{selectedEvent.eventLocation.address2 && <br />}
                            {selectedEvent.eventLocation.city}, {selectedEvent.eventLocation.state} {selectedEvent.eventLocation.zip}
                        </address>}

                        {!selectedEvent.eventLocation && <p>Hosted on Zoom</p>}

                        {selectedEvent.cost > 0 && <div>
                           <div className="row mb-2">
                               <div className="col-5">
                                   Fee: {selectedEvent.preDiscountCost ? <span style={{color: "grey", textDecoration: "line-through"}}>${selectedEvent.preDiscountCost.toFixed(2)}</span> : ""} ${selectedEvent.cost.toFixed(2)}
                               </div>
                               <div className="col-3">
                                   Tax: ${tax.toFixed(2)}
                               </div>
                               <div className="col-4 font-weight-bold">
                                   Total: ${(tax + selectedEvent.cost).toFixed(2)}
                               </div>
                           </div>


                            <div className="form-row">
                                <div className="form-group col-8">
                                    <label>Card Number</label>
                                    <input type="tel" name="CreditCardNumber" onChange={updateCreditCardForm}
                                        placeholder="4111 0001 1234 4567" className="form-control" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-6 form-group">
                                    <label>Exp. Month</label>
                                    <select name="ExpirationMonth" className="form-control" onChange={updateCreditCardForm}>
                                        <option>Month</option>
                                        <option value="1">January</option>
                                        <option value="2">February</option>
                                        <option value="3">March</option>
                                        <option value="4">April</option>
                                        <option value="5">May</option>
                                        <option value="6">June</option>
                                        <option value="7">July</option>
                                        <option value="8">August</option>
                                        <option value="9">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                </div>
                                <div className="col-4 form-group">
                                    <label>Exp. Year</label>
                                    <select name="ExpirationYear" className="form-control" onChange={updateCreditCardForm}>
                                        <option>Year</option>
                                        {years.map(y => <option value={y}>{y}</option>)}
                                    </select>
                                </div>
                                <div className="col-2 form-group">
                                    <label>CVV</label>
                                    <input type="tel" name="CvvCode" className="form-control" maxlength="4" placeholder="CVV"
                                        style={{ width: "60px" }} onChange={updateCreditCardForm} />
                                </div>
                            </div>
                        </div>}
                        <button className="btn btn-block btn-success" onClick={book} disabled={loading}>
                            Book It!
                        </button>
                        {selectedEvent.cost > 0 && refundText && <p className="mt-2 text-center">{refundText}</p>}
                    </div>
                </div>
            </div>}
{currentScreen === 3 && <div>
                <h1 className="text-center">You're Booked!</h1>

                <p></p>

                {selectedEvent.eventLocation && <>
                    <h2 className="text-center">Your event is located at:</h2>
                    
                    <address>
                        <strong>
                            {selectedEvent.eventLocation.name}
                        </strong><br />

                        {selectedEvent.eventLocation.address1}<br />
                        {selectedEvent.eventLocation.address2}{selectedEvent.eventLocation.address2 && <br />}
                        {selectedEvent.eventLocation.city}, {selectedEvent.eventLocation.state} {selectedEvent.eventLocation.zip}
                    </address>
                </>}

                {!selectedEvent.eventLocation && <p className="text-center">To join this event, please log into MyJC.me at your scheduled time. You will be prompted to join this meeting.</p>}

                <p className='text-center mt-2'>
                    <button className="btn btn-lg btn-primary mr-2" onClick={downloadIcs}>
                        <i className="fa fa-calendar"></i>
                            Add to Calendar
                        </button>
                    {selectedEvent.cost > 0 && <a href={`/BookPhotoshoot/Receipt?rsvpId=${rsvpId}&accountNumber=${accountNumber}`} className="btn btn-lg btn-success" target="_blank">
                        <i className="fa fa-usd"></i>
                        Print Receipt
                    </a>}
                </p>
            </div>}

{bottomMessage && <p className="text-center mt-2">{bottomMessage}</p>}
</>
    );
}